var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Interceptors from './Interceptors/Interceptors';
import Options from './Utils/Options';
import Loader from './Loaders/Loader';
import Emitter from './Utils/Emitter';
import Logger from './Utils/Logger';
//import fetchIntercept from "fetch-intercept";
/**
 * @class
 * @description Core class for the p2p plugin. It includes the options, the websocket communication,
 * @exports CdnBalancer
 */
export default class CdnBalancer extends Emitter {
    /**
     * Constructs CdnBalancer.
     * @param {constructionOptions} constructionOptions JSON with the options to construct the balancer.
     */
    constructor(constructionOptions) {
        super();
        this.options = new Options(constructionOptions);
        this._loader = new Loader(this.options);
        this.interceptors = new Interceptors(this);
        var cdnBalancer = this;
        //window.plugin.viewTransform.getViewCode()
        var requestHeader = XMLHttpRequest.prototype.setRequestHeader;
        XMLHttpRequest.prototype.setRequestHeader = function (name, value, ...rest) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore-next-line
            let segment = this.segment;
            if (segment) {
                segment.headers[name] = value;
                segment.retryBecauseNewHeaders = (segment.retryBecauseNewHeaders == 0) ? 1 : segment.retryBecauseNewHeaders;
            }
            requestHeader.call(this, name, value, ...rest);
        };
        var send = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function (data, ...rest) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore-next-line
                let segment = this.segment;
                if (!segment || segment.isManifest) {
                    try {
                        send.call(this, data, ...rest);
                    }
                    catch (e) { }
                    return;
                }
                if (segment.retryBecauseNewHeaders == 1) {
                    segment.retryBecauseNewHeaders = 2;
                    segment.updateP2PId();
                    cdnBalancer.openAndSend(this, segment);
                    return;
                }
                let init = Date.now();
                let segmenIsAvailableFromAPeer = false;
                // Beacuse is possible a headers appearet in the set headers function
                segment.updateP2PId();
                if (true) {
                    segmenIsAvailableFromAPeer = cdnBalancer.getLoader().P2PLoader.request(segment);
                    Logger.log("Is segment available via P2P " + segment.origRes + " " + segmenIsAvailableFromAPeer);
                }
                let p2p = segment.useP2P;
                // If p2p, tries to use load via p2p, if not, cdn
                if (!segmenIsAvailableFromAPeer) {
                    cdnBalancer.getLoader().CDNLoader.getActiveRequests().set(segment.id, segment);
                }
                else {
                    segment.cdnName = "P2P";
                    segment.cdnProvider = "P2P";
                    segment.useP2P = false; // just try once
                }
                if (!segment || !segment.rendition || !segment.rendition.targetDuration || segment.rendition.targetDuration <= 0 || segment.cdnName != 'P2P')
                    p2p = false;
                Logger.log(" Use P2P-> " + p2p + " " + segment.p2pId + " " + segment.id + " " + segment.cdnProvider + " " + segment.cdnName + " " + p2p + " " + ((_a = segment.rendition) === null || _a === void 0 ? void 0 : _a.targetDuration));
                if (!p2p) {
                    send.call(this, data, ...rest);
                }
                else {
                    //   let storedSegment = cdnBalancer._loader.P2PLoader.getSegment(segment);  
                    let storedSegment = cdnBalancer._loader.P2PLoader.getSegment(segment);
                    let data = storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.data;
                    let ready = storedSegment && (storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.data.byteLength) > 0 && ((data === null || data === void 0 ? void 0 : data.byteLength) === (storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.realBodySize));
                    let lastLenght = 0;
                    let timeout = (((_b = segment.rendition) === null || _b === void 0 ? void 0 : _b.targetDuration) || 0) * 1000 / 4;
                    Logger.log("P2P Request TIMEOUT " + timeout);
                    while (!ready) {
                        yield new Promise(f => setTimeout(f, 50));
                        storedSegment = cdnBalancer._loader.P2PLoader.getSegment(segment);
                        data = storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.data;
                        lastLenght = (data === null || data === void 0 ? void 0 : data.byteLength) || 0;
                        ready = storedSegment && (storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.data.byteLength) > 0 && ((data === null || data === void 0 ? void 0 : data.byteLength) === (storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.realBodySize));
                        if (Date.now() - init > timeout) {
                            ready = true;
                            data = undefined;
                        }
                        else if ((Date.now() - init) > 250 && (storedSegment == undefined || storedSegment.data == undefined || lastLenght < 20)) {
                            ready = true;
                            data = undefined;
                        }
                    }
                    storedSegment = cdnBalancer._loader.P2PLoader.getSegment(segment);
                    if (data && (data === null || data === void 0 ? void 0 : data.byteLength) == (storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.realBodySize)) {
                        let re = new CustomEvent('readystatechange');
                        let le = new CustomEvent('loadend');
                        let loade = new CustomEvent('load');
                        let loadStarte = new CustomEvent('loadstart');
                        Object.defineProperty(this, 'response', { writable: true });
                        // Object.defineProperty(this, 'responseText',       {writable: true} );  
                        Object.defineProperty(this, 'status', { writable: true });
                        Object.defineProperty(this, 'statusText', { writable: true });
                        Object.defineProperty(this, 'readyState', { writable: true });
                        Object.defineProperty(this, 'byteLength', { writable: true });
                        Object.defineProperty(this, 'responseURL', { writable: true });
                        Object.defineProperty(this, 'responseType', { writable: true });
                        this.dispatchEvent(re);
                        this.readyState = XMLHttpRequest.LOADING;
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore-next-line
                        this.byteLength = data.byteLength;
                        this.response = data;
                        this.status = 200;
                        this.statusText = 'OK';
                        this.readyState = XMLHttpRequest.DONE;
                        this.responseURL = segment.getNewUrl();
                        this.responseType = 'arraybuffer';
                        // this.dispatchEvent(loade);
                        this.dispatchEvent(re);
                        this.dispatchEvent(loade);
                        this.dispatchEvent(le);
                        Logger.log("P2P Download done -> " + (Date.now() - init) + "ms id:" + segment.p2pId);
                    }
                    else {
                        cdnBalancer.getLoader().CDNLoader.updateUrl(segment);
                        cdnBalancer.openAndSend(this, segment);
                    }
                }
            });
        };
        /****************** OPEN *********************/
        var open = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (method, url, ...rest) {
            let urlTest = url;
            let originalUrl = url;
            let byteLength = 0;
            let dontRewrite = false;
            let splitted = urlTest.split('?');
            urlTest = splitted[0];
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore-next-line
            if (this.segment == undefined) {
                Object.defineProperty(this, 'segment', { writable: true });
            }
            if (!url.includes("&rnpaw=") && !url.includes("?rnpaw="))
                if (method === "GET" && (urlTest.endsWith(".mp4") || urlTest.endsWith(".ts") || urlTest.endsWith(".m4s") || urlTest.endsWith(".mpd") || urlTest.endsWith(".m3u8"))) {
                    let params;
                    if (splitted.length > 1)
                        params = splitted[1];
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore-next-line
                    let segment = this.segment;
                    if (segment == undefined)
                        segment = cdnBalancer.simpleRequest(urlTest, params, {});
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore-next-line
                    if (this.segment == undefined) {
                        this.segment = segment;
                    }
                    this.addEventListener('load', function (e) {
                        cdnBalancer.getLoader().loadStartEM(this, segment, e);
                    });
                    this.addEventListener('loadstart', function (e) {
                        cdnBalancer.getLoader().loadStartEM(this, segment, e);
                    });
                    let oldReady = this.onreadystatechange;
                    this.addEventListener('readystatechange', function () {
                        let isOk = cdnBalancer.getLoader().readyStateChangeEM(this, segment);
                        if (isOk === false) {
                            cdnBalancer.getLoader().CDNLoader.updateUrl(segment);
                            cdnBalancer.openAndSend(this, segment);
                        }
                    });
                    this.addEventListener('progress', function (e) {
                        cdnBalancer.getLoader().progressEM(this, segment, e);
                    });
                    this.addEventListener('loadend', function (e) {
                        cdnBalancer.getLoader().loadEndEM(this, segment, e);
                    });
                    this.addEventListener('error', function (e) {
                    });
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore-next-line
                    return open.call(this, method, segment.getNewUrl(), ...rest);
                }
            Logger.log("XHR-not-intercepted -> " + url);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore-next-line
            return open.call(this, method, url, ...rest);
        };
    }
    resolv() {
    }
    openAndSend(request, segment) {
        var _a;
        try {
            request.open("GET", segment.getNewUrl());
            if ((_a = segment.headers) === null || _a === void 0 ? void 0 : _a.Range) {
                request.setRequestHeader("Range", segment.headers.Range);
            }
            request.send();
        }
        catch (error) {
        }
    }
    /**
     * Redirects adapter's requests to loader.
     * If loader is not ready yet it retries again after 200ms.
     * @param {URL} url URL object for the request.
     * @param {callback} callback Callback method to call back when loaded.
     * @param {Object} headers Optional headers of the request.
     * @param {number} retries Number of retries before giving up to load a segment if it fails, optional.
     * @param {boolean} forceArrayBuffer set as true if is expected to get the manifest response in ArrayBuffer format.
     * @public
     */
    request(url, download, callbacks, headers, retries, forceArrayBuffer, stats) {
        this._loader.processSegment(url, true, callbacks, headers, retries, forceArrayBuffer, stats);
    }
    /**
     * Sets the manifest URL of the played content to the options object.
     * For url changes the loader is restarted.
     * @param {string} url Manifest url of the content being played.
     * @public
     */
    setManifestResource(url) {
        if (url && this.options.resource !== url) {
            this.options.resource = url;
            this._loader = new Loader(this.options);
            this._loader.loadCDNBalancerData();
        }
    }
    getLoader() {
        return this._loader;
    }
    addInterceptor(name, player) {
        this.interceptors.loadInterceptor(name, player);
    }
    simpleRequest(urlString, params, headers) {
        let url = new URL(urlString);
        if ((this.options.resource == undefined || this.options.resource === '')) {
            this.setManifestResource(url.toString());
        }
        let segment = this._loader.processSegment(url, false, [], headers);
        let override = (this.options.overrideManifest && segment.isManifest);
        segment.params = params;
        const header = (headers === null || headers === void 0 ? void 0 : headers.Range) || '';
        this._loader.segmentsMap.set(segment.getNewUrl() + header, url.toString());
        return segment;
    }
}
